import {
  Component,
  OnInit,
} from "@angular/core";
import { KycService } from "@app/core/kyc.service";
import { Router } from "@angular/router";
import { routerTransition } from "@app/router.animations";
import { NavTabService } from "@app/core/navTab.service";
import { onQuestiones } from "@app/features/coverage/coverage"
import * as _ from "lodash";
declare var $;

@Component({
  selector: "app-needs",
  templateUrl: "./needs.component.html",
  animations: [routerTransition()],
  host: { "[@routerTransition]": "" }
})
export class MyNeedsComponent implements OnInit {
  questionNeeds: any;
  isError: boolean = true;
  isSlider: boolean;
  constructor(
    private kycService: KycService,
    private router: Router,
    private navTabService: NavTabService
  ) { }



  ngOnInit() {
    const { questionNeedAssessments } = this.kycService.kyc.needs
    const { userProfile } = this.kycService.kyc.profile;
    this.isSlider = ((Number(userProfile.marital) === 1 || String(userProfile.marital) === "") && (userProfile.kids === null || userProfile.kids === 0)) ? true : false;
    const data = _.map(questionNeedAssessments, (item) => (item.KYCQuestion.Order === 3 || item.KYCQuestion.Order === 0) ? undefined : item).filter(item => item)
    if (this.isSlider) {
      const config = _.map(data, item => item.KYCQuestionId !== "be9de10d-2b42-4159-8430-8683fefecec5" ? item : undefined).filter(item => item)
      this.questionNeeds = Object.values(_.groupBy(config, 'KYCQuestionId'))
      _.map(questionNeedAssessments, item => item.KYCQuestionId === "be9de10d-2b42-4159-8430-8683fefecec5" ? item : undefined).filter(item => item).filter(item => item.Order === 0)[0].Answer = true;
      //console.log(_.map(questionNeedAssessments, item => item.KYCQuestionId === "be9de10d-2b42-4159-8430-8683fefecec5" ? item : undefined).filter(item => item).filter(item => item.Order === 0)[0].Answer)
    } else {
      this.questionNeeds = Object.values(_.groupBy(data, 'KYCQuestionId'))
      _.map(questionNeedAssessments, item => item.KYCQuestionId === "be9de10d-2b42-4159-8430-8683fefecec5" ? item : undefined).filter(item => item).filter(item => item.Order === 0)[0].Answer = false;
    }
  }

  setInsuranceActive(answer: {
    KYCQuestionId: string;
    Id: string;
    Name: string;
    Order: number;
    Answer: boolean;
  }, questiones) {
    onQuestiones(answer, questiones);
  }



  goToNextPage() {
    const question_0 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 6).filter(item => item.Answer === true).length !== 0 ;
    const question_1 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 2).filter(item => item.Answer === true).length !== 0 ;
    const question_2 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 1).filter(item => item.Answer === true).length !== 0 ;
    const question_3 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 7).filter(item => item.Answer === true).length !== 0 ;
    const question_4 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 4).filter(item => item.Answer === true).length !== 0 ;
    const question_5 = _.filter(this.kycService.kyc.needs.questionNeedAssessments, item => item.KYCQuestion.Order === 5).filter(item => item.Answer === true).length !== 0 ;
    if (question_0 && question_1 && question_2 && question_3 && question_4 && question_5) {
      this.isError = true;
    } else {
      this.isError = false;
    }
    if (this.isError) {
      this.kycService.kyc.needs.completed = true;
      let tenant = this.kycService.getTenant();
      this.router.navigateByUrl("/" + tenant + "/journey/my-financial");
      this.navTabService.setActiveTab("financial");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/features/my-needs/needs.component.ts